import * as React from 'react';
import type { TFunctionalPerformanceDocumentType } from '../../utils';
import UHDRSFunctionalAssessmentForm from './UHDRSFunctionalAssessment';
import UHDRSFunctionalCapacityForm from './UHDRSFunctionalCapacity';
import UHDRSIndependenceScaleForm from './UHDRSIndependenceScale';
import ModifiedRankinScaleForm from './ModifiedRankinScale';
import ModifiedChildrensGlobalAssessmentScaleForm from './ModifiedChildrensGlobalAssessmentScale';

const FunctionalPerformanceForm = ({ formData, document, viewing = false }: IOwnProps): React.JSX.Element | null => {
  switch (document?._type) {
    case 'uhdrsFunctionalAssessment':
      return <UHDRSFunctionalAssessmentForm formData={formData} viewing={viewing} />;
    case 'uhdrsIndependenceScale':
      return <UHDRSIndependenceScaleForm formData={formData} viewing={viewing} />;
    case 'uhdrsFunctionalCapacity':
      return <UHDRSFunctionalCapacityForm formData={formData} viewing={viewing} />;
    case 'modifiedRankinScale':
      return <ModifiedRankinScaleForm formData={formData} viewing={viewing} />;
    case 'modifiedChildrensGlobalAssessmentScale':
      return <ModifiedChildrensGlobalAssessmentScaleForm formData={formData} viewing={viewing} />;
    default:
      return null;
  }
};

interface IOwnProps {
  formData: IFormData;
  document?: IDocumentWithTypeV2<TFunctionalPerformanceDocumentType>;
  viewing?: boolean;
}

export default FunctionalPerformanceForm;
